import React from 'react';
import { useLingui } from '@lingui/react/macro';

import OverflowTextModal from '@rover/components/src/OverflowTextModal/OverflowTextModal';

import { sendSectionInteractionEvent } from '../../utils/sendSectionInteractionEvent';

const InfoAboutPet = ({
  info,
  sitterShortName,
}: {
  info: string;
  sitterShortName: string;
}): JSX.Element => {
  const { t } = useLingui();
  const title = t`Information ${sitterShortName} would like to know about your pet`;

  return (
    <OverflowTextModal
      title={title}
      text={info}
      onReadMore={() => {
        sendSectionInteractionEvent('requested-dog-info');
      }}
    />
  );
};

export default InfoAboutPet;
